module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "create-game-page"
    }
  }, [_c('h2', [_vm._v("Create a new Game Project")]), _vm._v(" "), _c('section', {
    staticClass: "project-field"
  }, [_c('h1', [_vm._v("Basic Info")]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('label', [_c('span', [_vm._v("Game Project Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectTitle),
      expression: "projectTitle"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.projectTitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.projectTitle = $event.target.value
      }, function($event) {
        _vm.formErrors = []
      }]
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Maturity Rating")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating),
      expression: "rating"
    }],
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Everyone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "teen"
    }
  }, [_vm._v("Teen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mature"
    }
  }, [_vm._v("Mature")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adult"
    }
  }, [_vm._v("Adult")])])])])]), _vm._v(" "), (Object.keys(_vm.platforms).length > 0) ? _c('section', {
    staticClass: "project-field"
  }, [_c('h1', [_vm._v("Platforms ")]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, _vm._l((_vm.platforms), function(category) {
    return _c('div', {
      staticClass: "platform-fields"
    }, [_c('h1', [_vm._v(_vm._s(category.label))]), _vm._v(" "), _c('div', {
      staticClass: "platforms"
    }, [_vm._l((category.platforms), function(platform) {
      return _c('label', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!platform.initiallyHidden || category.showHidden),
          expression: "!platform.initiallyHidden || category.showHidden"
        }]
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (platform.checked),
          expression: "platform.checked"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": _vm.isSaving
        },
        domProps: {
          "checked": Array.isArray(platform.checked) ? _vm._i(platform.checked, null) > -1 : (platform.checked)
        },
        on: {
          "change": function($event) {
            _vm.formErrors = []
          },
          "__c": function($event) {
            var $$a = platform.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (platform.checked = $$a.concat($$v))
              } else {
                $$i > -1 && (platform.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              platform.checked = $$c
            }
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(platform.label))])])
    }), _vm._v(" "), (!category.showHidden && category.hasHidden) ? _c('label', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showHidden(category)
        }
      }
    }, [_vm._v("Show All " + _vm._s(category.label))])]) : _vm._e(), _vm._v(" "), (category.showHidden && category.hasHidden) ? _c('label', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.hideHidden(category)
        }
      }
    }, [_vm._v("Hide Extra " + _vm._s(category.label))])]) : _vm._e()], 2)])
  }))]) : _vm._e(), _vm._v(" "), (_vm.genres.length > 0) ? _c('section', {
    staticClass: "project-field genres"
  }, [_c('h1', [_vm._v("Genres")]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, _vm._l((_vm.genres), function(genre) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (genre.checked),
        expression: "genre.checked"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isSaving
      },
      domProps: {
        "checked": Array.isArray(genre.checked) ? _vm._i(genre.checked, null) > -1 : (genre.checked)
      },
      on: {
        "change": function($event) {
          _vm.formErrors = []
        },
        "__c": function($event) {
          var $$a = genre.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (genre.checked = $$a.concat($$v))
            } else {
              $$i > -1 && (genre.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            genre.checked = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(genre.label))])])
  }))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e()]), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('section', {
    staticClass: "project-field"
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createProject($event)
      }
    }
  }, [_vm._v("Create Game Project")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d171b0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/CreateGame/CreateGamePage.vue
// module id = 855
// module chunks = 2